import { Environment, ENVIRONMENT_CONFIG } from 'store/constants';

export const getBaseSubPath = () => {
  const pathSegments = window.location.pathname.split('/');
  const hasMemberWebInPath = pathSegments.includes('member-web');
  return hasMemberWebInPath ? '/member-web' : '';
};

export const getEnvironment = (): Environment => {
  const normalisedHost = window.location.host.toLowerCase();

  // Isolating localhost to prevent match with ENVIRONMENT_CONFIG
  if (normalisedHost.includes('localhost')) {
    return 'local';
  }

  const env = ENVIRONMENT_CONFIG.find(({ identifier }) =>
    normalisedHost.includes(identifier.toLowerCase()),
  )?.identifier;

  if (env) {
    return env;
  }

  return 'production';
};
